import { gql } from 'apollo-angular';

export var update_review_findings = gql`
  mutation updateReviewFindings($id: ID, $project_id: ID!, $construction_review_findings: String!) {
    updateReviewFindings(id: $id, project_id: $project_id, construction_review_findings: $construction_review_findings){
      id, probable_max_loss, recognized_enviromental_conditions, construction_review_findings, environment_review_findings
    }
  }
`;

export var update_env_findings = gql`
  mutation updateEnvFindings($id: ID, $project_id: ID!, $environment_review_findings: String!) {
    updateEnvFindings(id: $id, project_id: $project_id, environment_review_findings: $environment_review_findings){
      id, probable_max_loss, recognized_enviromental_conditions, construction_review_findings, environment_review_findings
    }
  }
`;

export var update_construction_details = gql`
  mutation updateConstructionDetails($id: ID, $project_id: ID!, $probable_max_loss: Float, $recognized_enviromental_conditions: Boolean) {
    updateConstructionDetails(id: $id, project_id: $project_id, probable_max_loss: $probable_max_loss, recognized_enviromental_conditions: $recognized_enviromental_conditions){
      id, probable_max_loss, recognized_enviromental_conditions, construction_review_findings, environment_review_findings
    }
  }
`;
